import React, { Component } from 'react';
import { connect } from "react-redux";
import './leaderboard.css';

import { ListIcon } from '../../molecules/listItems/listItems';
import Tag from '../../atoms/tag/tag';

class Leaderboard extends Component {
  renderEmployees() {
    const { employees } = this.props

    // sort depending on points, high to low.
    employees.sort((a, b) => {
      return b.points - a.points;
    });
    return employees.slice(0, 5).map((employee, key) => {
      return  <ListIcon employee={employee} number={key+1} key={key} />
    })

  }
  render() {
    const { cubics } = this.props;
    return (
      <div id='leaderboard'>
        <div className='flex'>
          <h2>Total company high fives</h2>
          <Tag label={cubics} />
        </div>
        {this.renderEmployees()}
      </div>
    )
  }
}

function mapStateToProps(state) {
  return {
    employees: state.employees,
    cubics: state.general.company.companyCubics,
  };
}

export default connect(mapStateToProps)(Leaderboard);
